import { createFromIconfontCN } from "@ant-design/icons";
import { IconfontUrl } from "@/config";
const Iconfont = createFromIconfontCN({
  scriptUrl: IconfontUrl,
  //   scriptUrl: "/static/iconfont/iconfont.js",
});
export default Iconfont;
